import { Controller } from "@hotwired/stimulus"

// Desktop-only timed popup CTA in bottom-right corner.
// Appears after a delay. Once dismissed, stays hidden for the session.
export default class extends Controller {
  static targets = ["popup"]
  static values = { delay: { type: Number, default: 8000 } }

  connect() {
    if (this.timeout) clearTimeout(this.timeout)

    if (!this.hasPopupTarget) return

    this.popupTarget.classList.add("translate-y-full", "opacity-0")
    this.popupTarget.classList.remove("translate-y-0", "opacity-100")

    if (window.innerWidth < 1024) return
    if (sessionStorage.getItem("rechner_popup_dismissed")) return

    this.timeout = setTimeout(() => {
      this.popupTarget.classList.remove("translate-y-full", "opacity-0")
      this.popupTarget.classList.add("translate-y-0", "opacity-100")
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.popupTarget.classList.add("translate-y-full", "opacity-0")
    this.popupTarget.classList.remove("translate-y-0", "opacity-100")
    sessionStorage.setItem("rechner_popup_dismissed", "1")
  }
}
